// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .store-details-section {
    background-color: #edf5fb;
    padding: 6px 52px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 22px 0px;
  }
  .underline {
    border-bottom: 2px solid ${(props) => props.theme.colorPalette.blue[200]};
    width: 150px;
    margin: 12px auto ${(props) => props.theme.spacing.ELEM_SPACING.XL} auto;
  }
  .submit-button {
    border-radius: 6px;
  }
  .capitalize-text {
    text-transform: capitalize;
  }
  .form-container {
    width: 33%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 85px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 89%;
    }
  }

  .close-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .store-location-section {
    text-align: center;
  }
  .back-anchor-style {
    color: black;
    border: none;
    background-color: white;
    font-family: Nunito;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    text-decoration: underline;
  }
  .left-arrow {
    border: solid ${(props) => props.theme.colors.ANCHOR.SECONDARY};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4.5px;
    cursor: pointer;
    transform: rotate(135deg);
  }
  .back-anchor-style .left-arrow {
    border-color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }
  .footer-section {
    margin-top: 150px;
    background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    padding: 22px 18px;
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 100vw;
      position: relative;
      left: calc(-45vw + 44%);
    }
    @media (max-width: 1536px) {
      padding-left: 36px;
    }
  }
  .footer-text {
    display: flex;
    align-items: center;
    margin-top: 10px;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-left: -15px;
      margin-right: -15px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 89%;
      align-items: flex-start;
    }
  }
  .footer-button {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  .info-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${(props) => (props.isShowSuccessMessageState ? `#338b2b` : `#C8102E`)};
    padding: 14px 32px;
    color: white;
    margin-top: -24px;
    margin-bottom: 24px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: 0px;
      padding: 12px;
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      margin-right: -144px;
      margin-left: -144px;
    }
    @media (max-width: 1536px) {
      margin-right: 0px;
      margin-left: 0px;
    }
  }
`;

export default styles;
